module.exports = __webpack_public_path__ + "img/vertical_7_4_8011.68103041.png";